















































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import {ITemplate, ISelectValue, IMessage, IMessageParseResult, ITag} from '@/interfaces';
import {
  readSenders,
  readServices,
  readTemplates,
  dispatchGetTemplates,
  dispatchDeleteTemplate,
  dispatchDeleteTemplates,
  dispatchGetServices,
  dispatchGetSenders,
  dispatchGetPriorities,
  dispatchParseMessage,
  dispatchUpdateTemplate,
  readPriorities,
  dispatchGetMNOs,
  readMNOs,
  dispatchSuggestTags,
} from '@/store/admin/accessors';
import VTextAreaWithValidation from '@/components/VTextAreaWithValidation.vue';
import { ValidationProvider } from 'vee-validate';
import * as _ from 'lodash';

@Component({
  components: {
    VTextAreaWithValidation,
  },
})
export default class Templates extends Vue {
  public dialog: boolean = false;
  public loading: boolean = false;
  public parseMessageTemplate!: ITemplate;
  public parseMessageResult: IMessageParseResult | null = null;
  public message: string = '';
  public valid = false;

  public templates: ITemplate[] = [];
  public totalTemplates: number = 0;

  public search: string = '';
  public servicesSelect: ISelectValue[] = [];
  public sendersSelect: ISelectValue[] = [];
  public prioritiesSelect: ISelectValue[] = [];
  public mnosSelect: ISelectValue[] = [];

  public tagsSearch: string = '';
  public tagsSelect: ISelectValue[] = [];
  public tagsFetchDebounce: Function | null = null;

  public selected: ITemplate[] = [];
  public pagination: { sortBy; descending; page; rowsPerPage; footerProps } = {
    sortBy: ['id'],
    descending: [false],
    page: 1,
    rowsPerPage: 20,
    footerProps: { 'items-per-page-options': [10, 20, 50, 100] },
  };
  public filters: {
    senderId: number | null;
    serviceId: number | null;
    priorityId: number | null;
    mnoBanId: number | null;
    tagId: number | null;
    activeCheckbox: boolean;
    notActiveCheckbox: boolean;
  } = {
    senderId: null,
    serviceId: null,
    priorityId: null,
    mnoBanId: null,
    tagId: null,
    activeCheckbox: true,
    notActiveCheckbox: true,
  };
  public $refs!: {
    observer: InstanceType<typeof ValidationProvider>;
  };
  private searchDelay: number | undefined;

  get headers() {
    return [
      {
        text: 'Service',
        sortable: true,
        value: 'service_name',
        align: 'left',
        width: '12%',
      },
      {
        text: 'Sender',
        sortable: true,
        value: 'sender_name',
        align: 'left',
        width: '13%',
      },
      {
        text: this.$vuetify.lang.t('$vuetify.priority'),
        sortable: true,
        value: 'priority',
        align: 'left',
        width: '8%',
      },
      {
        text: 'Template',
        sortable: true,
        value: 'template',
        align: 'left',
        width: '32%',
      },
      {
        text: 'MNO Bans',
        sortable: false,
        value: 'mno_bans',
        align: 'left',
        width: '10%',
      },
      {
        text: 'Actions',
        value: 'id',
      },
    ];
  }

  public updateTemplates() {
    this.loading = true;
    this.getDataFromApi().then(() => {
      this.loading = false;
    });
  }

  @Watch('pagination', { deep: true })
  public onPaginationChange(val) {
    this.updateTemplates();
  }

  @Watch('filters', { deep: true })
  public onFiltersChange(val) {
    this.updateTemplates();
  }

  @Watch('search')
  public onSearchChange(val) {
    clearTimeout(this.searchDelay);
    this.searchDelay = setTimeout(this.updateTemplates, 400);
  }

  public async mounted() {
    await dispatchGetServices(this.$store);
    await dispatchGetSenders(this.$store);
    await dispatchGetPriorities(this.$store);
    await dispatchGetMNOs(this.$store);
    for (const item of readServices(this.$store)) {
      const value: ISelectValue = { text: item.name, value: item.id };
      this.servicesSelect.push(value);
    }
    for (const item of readSenders(this.$store)) {
      const value: ISelectValue = { text: item.name, value: item.id };
      this.sendersSelect.push(value);
    }
    for (const item of readPriorities(this.$store)) {
      const value: ISelectValue = { text: item.name, value: item.id };
      this.prioritiesSelect.push(value);
    }
    for (const item of readMNOs(this.$store)) {
      const value: ISelectValue = { text: item.name, value: item.id };
      this.mnosSelect.push(value);
    }
    this.updateTemplates();
  }

  public async deleteTemplate(id: number) {
    if (confirm('Are you sure you want to delete this template?')) {
      await dispatchDeleteTemplate(this.$store, id);
      this.updateTemplates();
    }
  }

  public async changeTemplateStatus(template: ITemplate) {
    await dispatchUpdateTemplate(this.$store, { id: template.id, template: { active: template.active } });
  }

  public async deleteTemplates() {
    if (confirm('Are you sure you want to delete selected templates?')) {
      const selected = this.selected.map((item) => item.id as number);
      await dispatchDeleteTemplates(this.$store, selected);
      this.updateTemplates();
    }
  }

  @Watch('dialog')
  public onDialogChange(val) {
    return val || this.parseMessageClose();
  }

  public parseMessage(template) {
    this.parseMessageTemplate = template;
    this.dialog = true;
  }

  public parseMessageClose() {
    this.message = '';
    this.dialog = false;
    this.$refs.observer.reset();
  }

  public async getDataFromApi() {
    const { sortBy, descending, page, rowsPerPage } = this.pagination;
    const skip = (page - 1) * rowsPerPage;
    await dispatchGetTemplates(this.$store, {
      skip,
      search: this.search,
      limit: rowsPerPage,
      orderBy: sortBy[0],
      descending: descending[0],
      serviceId: this.filters.serviceId,
      senderId: this.filters.senderId,
      priorityId: this.filters.priorityId,
      mnoBanId: this.filters.mnoBanId,
      tagId: this.filters.tagId,
      active:
        this.filters.activeCheckbox && !this.filters.notActiveCheckbox
          ? true
          : !this.filters.activeCheckbox && this.filters.notActiveCheckbox
          ? false
          : null,
    });
    this.templates = readTemplates(this.$store).items;
    this.totalTemplates = readTemplates(this.$store).total;
  }

  public async submit() {
    if (await this.$refs.observer.validate()) {
      const messageToParse: IMessage = {
        template_id: this.parseMessageTemplate.id,
        message: this.message,
      };
      const result = await dispatchParseMessage(this.$store, messageToParse);
      if (result) {
        this.parseMessageResult = result;
      } else {
        this.parseMessageResult = null;
      }
    }
  }

  public async setTagFilter(tag: ITag) {
    this.tagsSearch = tag.text;
    this.filters.tagId = tag.id;
  }

  @Watch('tagsSearch')
  private async tagsSearchChanged() {
    this.tagsFetchDebounce =
      this.tagsFetchDebounce ||
      _.debounce(() => {
        dispatchSuggestTags(this.$store, this.tagsSearch).then(
          (data) => (this.tagsSelect = data ? data.map((item) => ({ text: item.text, value: item.id })) : []),
        );
      }, 250);
    this.tagsFetchDebounce();
  }
}
